/**
 * Account Deletion Success Page
 * Shown after a user has successfully requested account deletion.
 * This page is public and does not use the admin MainLayout.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, PrimaryButton } from '../../components/ui';

const AccountDeletionSuccessPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 520,
          boxShadow: theme.shapes?.shadow?.lg || theme.shadows[4],
        }}
      >
        <CardContent
          sx={{
            padding: theme.spacing(4),
            '&:last-child': {
              paddingBottom: theme.spacing(4),
            },
          }}
        >
          <Box sx={{ marginBottom: theme.spacing(2.5) }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: theme.palette.text.primary,
                marginBottom: theme.spacing(1),
              }}
            >
              Account Deletion Requested
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                lineHeight: 1.6,
              }}
            >
              Your account deletion request has been submitted. Your account and personal data will
              be deleted in accordance with our data retention and legal obligations.
            </Typography>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              marginBottom: theme.spacing(3),
            }}
          >
            If you reached this page from the MiSpy mobile app, you can safely close this window and
            return to the app.
          </Typography>
          
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccountDeletionSuccessPage;

